"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var Misc = _interopRequireWildcard(require("@/helpers/Misc"));
var TextFormatting = _interopRequireWildcard(require("@/helpers/TextFormatting"));
var EmojiProvider = _interopRequireWildcard(require("@/libs/EmojiProvider"));
var settingTools = _interopRequireWildcard(require("@/libs/settingTools"));
var _autocompleteCommands = _interopRequireDefault(require("@/res/autocompleteCommands"));
var _GlobalApi = _interopRequireDefault(require("@/libs/GlobalApi"));
var _AutoComplete = _interopRequireDefault(require("./AutoComplete"));
var _TextStyle = _interopRequireDefault(require("./inputtools/TextStyle"));
var _Emoji = _interopRequireDefault(require("./inputtools/Emoji"));
var _SelfUser = _interopRequireDefault(require("./SelfUser"));
var _AwayStatusIndicator = _interopRequireDefault(require("./AwayStatusIndicator"));
var _TypingUsersList = _interopRequireDefault(require("./TypingUsersList"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var _default = exports.default = {
  components: {
    AutoComplete: _AutoComplete.default,
    AwayStatusIndicator: _AwayStatusIndicator.default,
    SelfUser: _SelfUser.default,
    TypingUsersList: _TypingUsersList.default
  },
  props: ['network', 'buffer', 'sidebarState'],
  data() {
    return {
      self: this,
      selfuser_open: false,
      autocomplete_open: false,
      autocomplete_items: [],
      autocomplete_filter: '',
      // Not filtering through the autocomplete list means that the entire word is put
      // in place when cycling through items. Just as with traditional IRC clients when
      // tabbing through nicks.
      // When filtering through the list, we keep typing more of the word we want as the
      // autocomplete list filters its results to show us the relevant items, not replacing
      // the current word until we select an item.
      autocomplete_filtering: true,
      active_tool: null,
      active_tool_props: {},
      pluginUiElements: _GlobalApi.default.singleton().controlInputPlugins,
      showPlugins: false,
      showCommandWarning: false,
      current_input_value: '',
      has_focus: false,
      keep_focus: false
    };
  },
  computed: {
    currentNick() {
      let activeNetwork = this.$state.getActiveNetwork();
      return activeNetwork ? activeNetwork.nick : '';
    },
    networkState() {
      let activeNetwork = this.$state.getActiveNetwork();
      return activeNetwork ? activeNetwork.state : '';
    },
    shouldShowSendButton() {
      return this.$state.ui.is_touch || this.$state.setting('showSendButton');
    },
    shouldShowEmojiPicker() {
      return this.$state.setting('forceShowEmojiPicker') || this.$state.setting('showEmojiPicker');
    },
    shouldShowColorPicker() {
      return this.$state.setting('showColorPicker');
    },
    shouldShowTools() {
      if (this.pluginUiElements.length || this.shouldShowEmojiPicker || this.shouldShowColorPicker) {
        return true;
      }
      return false;
    },
    shouldShowToolsInline() {
      let toolCount = this.pluginUiElements.length;
      if (this.shouldShowEmojiPicker) {
        toolCount++;
      }
      if (this.shouldShowColorPicker) {
        toolCount++;
      }
      if (toolCount === 1) {
        // No point showing a menu button to replace one item
        return true;
      }

      // Button size (36px)
      // Total buttons width < 1/5 screen width
      return 36 * toolCount < this.$state.ui.app_width / 5;
    },
    history() {
      if (this.$state.setting('buffers.shared_input')) {
        return this.$state.ui.input_history;
      }
      return this.buffer.input_history;
    },
    history_pos: {
      get() {
        if (this.$state.setting('buffers.shared_input')) {
          return this.$state.ui.input_history_pos;
        }
        return this.buffer.input_history_pos;
      },
      set(newVal) {
        if (this.$state.setting('buffers.shared_input')) {
          this.$state.ui.input_history_pos = newVal;
        } else {
          this.buffer.input_history_pos = newVal;
        }
      }
    }
  },
  watch: {
    history_pos(newVal) {
      let val = this.history[this.history_pos];
      this.$refs.input.setValue(val || '');
    },
    buffer() {
      if (!this.$state.setting('buffers.shared_input')) {
        this.inputRestore();
      }
      this.autocomplete_open = false;
    }
  },
  created() {
    this.typingTimer = null;
    this.lastTypingTime = 0;
    this.listen(this.$state, 'document.keydown', ev => {
      // No input box currently? Nothing to shift focus to
      if (!this.$refs.input) {
        return;
      }

      // If we're copying text, don't shift focus
      if (ev.ctrlKey || ev.altKey || ev.metaKey) {
        return;
      }

      // shift key on its own, don't shift focus we handle this below
      if (ev.key === 'Shift') {
        return;
      }

      // If we are using shift and arrow keys, don't shift focus
      // this allows users to adjust text selection
      let arrowKeyCodes = ['ArrowLeft', 'ArrowUp', 'ArrowRight', 'ArrowDown'];
      if (ev.shiftKey && arrowKeyCodes.indexOf(ev.key) !== -1) {
        return;
      }

      // If we're typing into an input box somewhere, ignore
      let elements = ['input', 'select', 'textarea', 'button', 'datalist', 'keygen'];
      let doNotRefocus = elements.indexOf(ev.target.tagName.toLowerCase()) > -1 || ev.target.getAttribute('contenteditable');
      if (doNotRefocus) {
        return;
      }
      this.$refs.input.focus();
    });
    this.listen(this.$state, 'input.insertnick', nick => {
      if (!this.$refs.input) {
        return;
      }
      let val = nick;
      if (this.current_input_value === '') {
        val += ': ';
      } else {
        val += ' ';
      }
      this.$refs.input.insertText(val);
    });
    this.listen(this.$state, 'input.tool', toolComponent => {
      this.toggleInputTool(toolComponent);
    });
  },
  mounted() {
    this.inputRestore();
  },
  methods: {
    inputUpdate(val) {
      this.current_input_value = val;
      if (this.$state.setting('buffers.shared_input')) {
        this.$state.ui.current_input = val;
      } else {
        this.buffer.current_input = val;
      }

      // Clear the command warning on any new input
      this.showCommandWarning = false;
      this.maybeHidePlugins();
    },
    inputRestore() {
      let currentInput = this.$state.setting('buffers.shared_input') ? this.$state.ui.current_input : this.buffer.current_input;
      this.$refs.input.reset(currentInput, this.keep_focus);
      this.$refs.input.selectionToEnd();
    },
    toggleSelfUser() {
      if (this.networkState === 'connected') {
        this.selfuser_open = !this.selfuser_open;
      }
    },
    maybeHidePlugins() {
      // Save some space if we're typing on a small screen
      if (this.$state.ui.app_width < 500) {
        this.showPlugins = false;
      }
    },
    onToolClickTextStyle() {
      this.toggleInputTool(_TextStyle.default);
    },
    onToolClickEmoji() {
      this.toggleInputTool(_Emoji.default);
    },
    closeToolsPlugins() {
      this.showPlugins = false;
      this.closeInputTool();
    },
    closeInputTool() {
      this.active_tool = null;
    },
    toggleInputTool(tool) {
      if (!tool || this.active_tool === tool) {
        this.active_tool = null;
      } else {
        this.active_tool_props = {
          buffer: this.buffer,
          ircinput: this.$refs.input,
          closeInputTool: () => this.closeInputTool()
        };
        this.active_tool = tool;
      }
    },
    toggleBold() {
      this.$refs.input.toggleBold();
    },
    toggleItalic() {
      this.$refs.input.toggleItalic();
    },
    toggleUnderline() {
      this.$refs.input.toggleUnderline();
    },
    onAutocompleteCancel() {
      this.autocomplete_open = false;
    },
    onAutocompleteTemp(selectedValue, selectedItem) {
      if (!this.autocomplete_filtering) {
        this.$refs.input.setCurrentWord(selectedValue);
      }
    },
    onAutocompleteSelected(selectedValue, selectedItem) {
      let word = selectedValue;
      if (word.length > 0) {
        this.$refs.input.setCurrentWord(word);
      }
      this.autocomplete_open = false;
    },
    inputKeyDown(event) {
      let meta = false;
      if (navigator.appVersion.indexOf('Mac') !== -1) {
        meta = event.metaKey;
      } else {
        meta = event.ctrlKey;
      }

      // If autocomplete has handled the event, don't also handle it here
      if (this.autocomplete_open && this.$refs.autocomplete.handleOnKeyDown(event)) {
        return;
      }

      // When not filtering, select the current autocomplete item so that we can type any
      // character directly after a nick
      if (this.autocomplete_open && !this.autocomplete_filtering) {
        this.$refs.autocomplete.selectCurrentItem();
      }
      if (event.key === 'Enter' && (event.altKey && !event.shiftKey && !event.metaKey && !event.ctrlKey || event.shiftKey && !event.altKey && !event.metaKey && !event.ctrlKey)) {
        // Add new line when shift+enter or alt+enter is pressed
        event.preventDefault();
        this.$refs.input.insertText('\n');
      } else if (event.key === 'Enter') {
        // Send message when enter is pressed
        event.preventDefault();
        this.submitForm();
      } else if (event.key === 'Escape' && this.showCommandWarning) {
        // Close command warning if the user presses escape
        this.showCommandWarning = false;
      } else if (event.key === ' ') {
        // Hitting space after just typing an ascii emoji will get it replaced with
        // its image
        if (this.$state.setting('buffers.show_emoticons')) {
          let currentWord = this.$refs.input.getCurrentWord(true);
          let emojis = EmojiProvider.getEmojis(currentWord.word);
          if (emojis.length) {
            event.preventDefault();
            this.$refs.input.setCurrentWord('', false, true);
            this.$refs.input.addImg(emojis[0].ascii, emojis[0].url, emojis[0].imgProps);
          }
        }
      } else if (event.key === 'ArrowUp') {
        // Up
        if (this.$refs.input.getCaretIdx() > 0) {
          // not at the start of input, allow normal input behaviour
          return;
        }
        event.preventDefault();
        this.historyBack();
      } else if (event.key === 'ArrowDown') {
        // Down
        let end = this.$refs.input.getRawText().replace(/\r?\n/g, '').length;
        if (this.$refs.input.getCaretIdx() < end) {
          // not at the end of input, allow normal input behaviour
          return;
        }
        event.preventDefault();
        this.historyForward();
        this.$nextTick(() => {
          this.$refs.input.selectionToEnd();
        });
      } else if (event.key === 'Tab' && !event.shiftKey && !event.altKey && !event.metaKey && !event.ctrlKey) {
        // Tab and no other keys as tab+other is often a keyboard shortcut
        // Tab key was just pressed, start general auto completion
        let currentWord = this.$refs.input.getCurrentWord();
        let currentToken = currentWord.word.substr(0, currentWord.position);
        let inputText = this.$refs.input.getRawText();
        let items = [];
        if (inputText.indexOf('/set') === 0) {
          items = this.buildAutoCompleteItems({
            settings: true
          });
        } else {
          items = this.buildAutoCompleteItems({
            users: true,
            buffers: true
          });
        }
        this.openAutoComplete(items);
        this.autocomplete_filter = currentToken;

        // Disable filtering so that tabbing cycles through words more like
        // traditional IRC clients.
        this.autocomplete_filtering = false;
        event.preventDefault();
      } else if (meta && event.key === 'k') {
        // meta + k
        this.toggleInputTool(_TextStyle.default);
        event.preventDefault();
      } else if (meta && event.key === 'b') {
        // meta + b
        this.toggleBold();
        event.preventDefault();
      } else if (meta && event.key === 'i') {
        // meta + i
        this.toggleItalic();
        event.preventDefault();
      } else if (meta && event.key === 'u') {
        // meta + u
        this.toggleUnderline();
        event.preventDefault();
      }
    },
    inputKeyUp(event) {
      let inputVal = this.$refs.input.getRawText();
      let currentWord = this.$refs.input.getCurrentWord();
      let currentToken = currentWord.word.substr(0, currentWord.position);
      let autocompleteTokens = this.$state.setting('autocompleteTokens');
      if (event.key === 'Escape' && this.autocomplete_open) {
        this.autocomplete_open = false;
      } else if (this.autocomplete_open && currentToken === '') {
        this.autocomplete_open = false;
      } else if (this.autocomplete_open) {
        // @ is a shortcut to open the nicklist autocomplete. It's not part
        // of the nick so strip it out before passing currentToken to the
        // filter.
        if (currentToken[0] === '@') {
          currentToken = currentToken.substr(1);
        }
      } else if (currentToken === '@' && autocompleteTokens.includes('@')) {
        // Just typed @ so start the nick auto completion
        this.openAutoComplete(this.buildAutoCompleteItems({
          users: true
        }));
        this.autocomplete_filtering = true;
      } else if (inputVal === '/' && autocompleteTokens.includes('/')) {
        // Just typed / so start the command auto completion
        this.openAutoComplete(this.buildAutoCompleteItems({
          commands: true
        }));
        this.autocomplete_filtering = true;
      } else if (currentToken === '#' && autocompleteTokens.includes('#')) {
        // Just typed # so start the command auto completion
        this.openAutoComplete(this.buildAutoCompleteItems({
          buffers: true
        }));
        this.autocomplete_filtering = true;
      } else if (event.key === 'Tab' && !event.shiftKey && !event.altKey && !event.metaKey && !event.ctrlKey) {
        // Tab and no other keys as tab+other is often a keyboard shortcut
        event.preventDefault();
      } else if (!event.key.match(/^(Shift|Control|Alt|Enter)/)) {
        if (inputVal[0] === '/') {
          // Don't send typing status for commands
          return;
        }
        if (inputVal.trim()) {
          this.startTyping();
        } else {
          this.stopTyping(true);
        }
      }
      if (this.autocomplete_open && this.autocomplete_filtering) {
        this.autocomplete_filter = currentToken;
      }
    },
    submitForm() {
      let rawInput = this.$refs.input.getValue();
      if (!rawInput) {
        if (!this.has_focus && this.keep_focus) {
          // Maybe triggered by the send button on empty input,
          // put focus back into the input
          this.$refs.input.focus();
        }
        return;
      }
      let ircText = this.$refs.input.buildIrcText();

      // Show a warning if a command is preceded by spaces
      let warnExpectedCommand = this.$state.setting('buffers.warn_expected_command');
      if (warnExpectedCommand && !this.showCommandWarning) {
        const spacePrecededCommand = /^\s+\//;
        const hasPrecedingSpace = ircText.split('\n').some(line => spacePrecededCommand.test(Misc.stripStyles(line)));
        if (hasPrecedingSpace) {
          this.showCommandWarning = true;
          return;
        }
      }
      this.$state.$emit('input.raw', ircText);
      this.historyAdd(rawInput);
      this.$refs.input.reset('', this.keep_focus);
      this.stopTyping(false);
    },
    historyAdd(rawInput) {
      // Add to history, keeping the history trimmed to the last 50 entries
      this.history.push(rawInput);
      this.history.splice(0, this.history.length - 50);
      this.history_pos = this.history.length;
    },
    historyBack() {
      let rawText = this.$refs.input.getRawText();
      let rawInput = this.$refs.input.getValue();
      if (rawText.trim() && this.history_pos === this.history.length) {
        this.historyAdd(rawInput);
        this.history_pos--;
      }
      if (this.history_pos > 0) {
        this.history_pos--;
      }
    },
    historyForward() {
      // Purposely let history_pos go 1 index beyond the history length
      // so that we can detect if we're not currently using a history value
      if (this.history_pos < this.history.length) {
        this.history_pos++;
      }
    },
    focusChanged(event) {
      this.has_focus = event.type === 'focus';

      // iOS does not populate relatedTarget when the relatedTarget is the send button
      // leaving it impossible to detect if returning focus is required
      if (event.type === 'blur' && event.relatedTarget && event.relatedTarget === this.$refs.sendButton) {
        // new target is the send button, keep focus on reset
        return;
      }
      this.keep_focus = event.type === 'focus';
    },
    openAutoComplete(items) {
      if (this.$state.setting('showAutocomplete')) {
        this.autocomplete_items = items;
        this.autocomplete_open = true;
      }
    },
    buildAutoCompleteItems(_opts) {
      let opts = _opts || {};
      let list = [];
      if (opts.users) {
        let userList = _lodash.default.values(this.buffer.users).map(user => {
          let item = {
            text: user.nick,
            type: 'user'
          };
          return item;
        });
        if (this.buffer.isQuery()) {
          userList.push({
            text: this.buffer.name,
            type: 'user'
          });
        }
        list = list.concat(userList);
      }
      if (opts.buffers) {
        let bufferList = [];
        this.network.buffers.forEach(buffer => {
          if (buffer.isChannel()) {
            bufferList.push({
              text: buffer.name,
              type: 'buffer'
            });
          }
        });
        list = list.concat(bufferList);
      }
      if (opts.commands) {
        let commandList = [];
        _autocompleteCommands.default.forEach(command => {
          // allow descriptions to be translation keys or static strings
          let desc = command.description.indexOf('locale_id_') === 0 ? TextFormatting.t(command.description.substr(10)) : command.description;
          commandList.push({
            text: '/' + command.command,
            description: desc,
            type: 'command',
            // Each alias needs the / command prefix adding
            alias: (command.alias || []).map(c => '/' + c)
          });
        });
        list = list.concat(commandList);
      }
      if (opts.settings) {
        let out = {};
        let base = [];
        settingTools.buildTree(out, base, this.$state.getSetting('settings'), false);
        settingTools.buildTree(out, base, this.$state.getSetting('user_settings'), true);
        let settingList = [];
        Object.keys(out).forEach(setting => {
          settingList.push({
            text: setting,
            type: 'setting'
          });
        });
        list = list.concat(settingList);
      }
      return list;
    },
    startTyping() {
      if (!this.network.ircClient.network.cap.isEnabled('message-tags')) {
        return;
      }
      if (!this.buffer || !this.buffer.shouldShareTyping()) {
        return;
      }
      if (this.typingTimer) {
        clearTimeout(this.typingTimer);
        this.typingTimer = null;
      }
      this.typingTimer = setTimeout(() => this.stopTyping(true), 3000);
      if (Date.now() < this.lastTypingTime + 3000) {
        return;
      }
      this.network.ircClient.typing.start(this.buffer.name);
      this.lastTypingTime = Date.now();
    },
    stopTyping(sendStop) {
      if (!this.network.ircClient.network.cap.isEnabled('message-tags')) {
        return;
      }
      if (!this.buffer || !this.buffer.shouldShareTyping()) {
        return;
      }
      if (this.typingTimer) {
        clearTimeout(this.typingTimer);
        this.typingTimer = null;
        this.lastTypingTime = 0;
      }
      this.$refs.input.getRawText().trim() ? this.network.ircClient.typing.pause(this.buffer.name) : this.network.ircClient.typing.stop(this.buffer.name, sendStop);
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["ControlInput"]
window._kiwi_exports.components.ControlInput = exports.default ? exports.default : exports;
